export default {
  outList: [
    {
      light_point_1:[
        {
          title: '1.1m²超大防夹天窗',
          type: 'image',
          video: '',
          image: 'lightPoint/1/5.jpg',
          text: '带来180度视觉享受'
        },
        {
          title: '高强度车身',
          type: 'image',
          video: '',
          image: 'lightPoint/3/1.jpg',
          text: '坚固守护，安全无忧，为全家的每一次出行保驾护航。'
        },
      ],
      light_point_4:[
        {
          title: '晶耀钻石格栅',
          type: 'image',
          video: '',
          image: 'lightPoint/2/1.jpg',
          text: '虎威前脸，赋予自然王者风范的大气之美。镀铬钻石镶嵌其间，如夜空中繁星点点，在时间长河中光芒四射。'
        },
      ],
      light_point_5:[
        {
          title: '潮汐光幕尾灯',
          type: 'image',
          video: '',
          image: 'lightPoint/2/3.jpg',
          text: '以海洋永恒的呼吸为灵感原型，以及浪尖破碎时飞溅的星芒为设计母体。灯体通透质感车尾的流线造型相互呼应。'
        },
      ],
    }
  ],
  innerList: [
    {
      light_point_1:[
        {
          title: '24.6吋曲面沉浸环绕屏',
          type: 'image',
          video: '',
          image: 'lightPoint/1/1.jpg',
          text: '曲率3000R，1920*720高清分辨率，一眼超清视界，满屏细腻色彩'
        },
      ],
      light_point_2:[
        {
          title: '木兰红时尚潮流内饰',
          type: 'image',
          video: '',
          image: 'lightPoint/3/6.jpg',
          text: '红黑经典撞色设计，热烈与沉稳并存，菱形格纹，每一针一线皆显精致奢华'
        },
      ],
      light_point_3:[
        {
          title: '水晶钻石换挡把手',
          type: 'image',
          video: '',
          image: 'lightPoint/2/6.jpg',
          text: '2280余次用户真实握感测试,一推一拉间点燃年轻激情'
        }
      ],
      light_point_4:[
        {
          title: '一体式能量运动座椅',
          type: 'image',
          video: '',
          image: 'lightPoint/1/3.jpg',
          text: '奢侈品级绗缝工艺，定义潮流新标杆'
        },
      ]
    }
  ],
  tab1:[
    {
      title: '24.6吋曲面沉浸环绕屏',
      type: 'image',
      video: '',
      image: 'lightPoint/1/1.jpg',
      text: '曲率3000R，1920*720高清分辨率，一眼超清视界，满屏细腻色彩'
    },
    {
      title: 'LION 5.0雄狮智云交互科技',
      type: 'image',
      video: '',
      image: 'lightPoint/1/2.jpg',
      text: '出行随时随享，满载智慧生态'
    },
    {
      title: '一体式能量运动座椅',
      type: 'image',
      video: '',
      image: 'lightPoint/1/3.jpg',
      text: '奢侈品级绗缝工艺，定义潮流新标杆'
    },
    {
      title: '2670mm超长轴距',
      type: 'image',
      video: '',
      image: 'lightPoint/1/4.jpg',
      text: '空间更宽敞，后排腿部活动自如，带来越级乘坐体验'
    },
    {
      title: '1.1m²超大防夹天窗',
      type: 'image',
      video: '',
      image: 'lightPoint/1/5.jpg',
      text: '带来180度视觉享受'
    },
  ],
  tab2: [
    {
      title: '晶耀钻石格栅',
      type: 'image',
      video: '',
      image: 'lightPoint/2/1.jpg',
      text: '虎威前脸，赋予自然王者风范的大气之美。镀铬钻石镶嵌其间，如夜空中繁星点点，在时间长河中光芒四射。'
    },
    {
      title: '虎瞳凌眸大灯',
      type: 'image',
      video: '',
      image: 'lightPoint/2/2.jpg',
      text: '深邃犀利，目光如炬，犹如老虎捕猎，在夜色下匍匐向前，蓄势待发，尽显大气威严姿态'
    },
    {
      title: '潮汐光幕尾灯',
      type: 'image',
      video: '',
      image: 'lightPoint/2/3.jpg',
      text: '以海洋永恒的呼吸为灵感原型，以及浪尖破碎时飞溅的星芒为设计母体。灯体通透质感车尾的流线造型相互呼应。'
    },
    {
      title: '电动尾门',
      type: 'image',
      video: '',
      image: 'lightPoint/2/4.jpg',
      text: '一键启合，无需动手，为出行增添一抹从容与优雅。'
    },
    {
      title: '活力棕时尚潮流内饰',
      type: 'image',
      video: '',
      image: 'lightPoint/2/5.jpg',
      text: '黑棕色拼接设计，巧妙融合了黑色的现代力量感与棕色的自然豪华感'
    },
    {
      title: '水晶钻石换挡把手',
      type: 'image',
      video: '',
      image: 'lightPoint/2/6.jpg',
      text: '2280余次用户真实握感测试,一推一拉间点燃年轻激情'
    }

  ],
  tab3: [
    {
      title: '高强度车身',
      type: 'image',
      video: '',
      image: 'lightPoint/3/1.jpg',
      text: '坚固守护，安全无忧，为全家的每一次出行保驾护航。'
    },
    {
      title: '环抱式6安全气囊',
      type: 'image',
      video: '',
      image: 'lightPoint/3/2.jpg',
      text: '紧急时刻全方位安全防护，给家人满满安全感'
    },
    {
      title: '360°全景影像',
      type: 'image',
      video: '',
      image: 'lightPoint/3/3.jpg',
      text: '倒车更安全，盲区不担心'
    }
  ]
}
